import React from "react";
import { createPortal } from "react-dom";
import { colors2 } from "oolib";
import DirectDataImport from "./index";

/**
 * Modal wrapper around the DirectDataImport page.
 *
 * Optional props forward to the page so callers can launch flows other than
 * the default "create new dataset":
 *   - isImportMoreDataMode: skip the ContentTypeTitleModal step; the import
 *     appends to an existing tpl. Caller must also supply `contentType`.
 *   - contentType:          which tpl to append to (overrides useParams,
 *     which is unavailable when the modal opens on routes that don't carry
 *     `:contentType` in the path — like /integrations).
 *   - fromManage:           launched from an Integrations manage popup; the
 *     Slack import popup leaves out its connection card (the manage popup
 *     shows it) and offers Discard rather than Do Later.
 *   - autoSubmitExternal:   { sourceId, adapterOptions } to fetch on open,
 *     skipping the pick step (e.g. a manage popup's "Edit import settings").
 */
export const DirectDataImportModal = ({ isOpen, onClose, isImportMoreDataMode, contentType, entryPoint, resumePendingDirectDataImport, fromManage, autoSubmitExternal }) => {
  if (!isOpen) return null;

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) return null;

  return createPortal(
    <div
      style={{
        width: "100dvw",
        height: "100dvh",
        position: "fixed",
        left: 0,
        top: 0,
        // ModalConfirm's z-index is 999999999 — keep this lower so confirm modals stack above
        zIndex: 999999998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Single backdrop for both stages. The compact source/add-data step
        // renders oolib's Modal on top with hideBackdrop, so this is the only
        // tint; the full-size preview has no backdrop of its own either.
        background: colors2.grey50,
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
      }}
    >
      <DirectDataImport
        isModal
        onClose={onClose}
        isImportMoreDataMode={isImportMoreDataMode}
        contentType={contentType}
        entryPoint={entryPoint}
        resumePendingDirectDataImport={resumePendingDirectDataImport}
        fromManage={fromManage}
        autoSubmitExternal={autoSubmitExternal}
      />
    </div>,
    modalRoot
  );
};

export default DirectDataImportModal;
